import { useCallback, useEffect, useMemo, useState } from 'react';
import { Booking } from '../Types';
import { useSelector } from 'react-redux';
import { RootState } from '../Store/Reducers';
import useGlobals from './useGlobals';
import { creditService } from '../Services/creditService';

const useBilling = () => {
    const { handleNavigate, userSettings, i18n, demo, windowWidth, getBreakpoint, requestClient } = useGlobals();

    const [bookings, setBookings] = useState<Booking[]>([]);
    const selectedLanguage = useSelector((state: RootState) => state.i18n.selectedLanguage);
    const [bookingsLoaded, setBookingsLoaded] = useState<boolean>(false);

    const valueFormatter = useCallback(
        (number: number | string) => {
            const parsedNumber = Number(number);
            if (isNaN(parsedNumber)) {
                console.warn('Invalid number passed to valueFormatter:', number);
                return '$ 0.00';
            }

            return `$ ${new Intl.NumberFormat(selectedLanguage, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(parsedNumber)}`;
        },
        [selectedLanguage],
    );

    useEffect(() => {
        creditService.getBooking().then((response: { data: { data: Booking[]; total: number } }) => {
            setBookings(() =>
                response.data.data.map((booking: Booking) => {
                    return {
                        identifier: booking.identifier,
                        title: booking.title,
                        amount: valueFormatter(booking.amount),
                        date: new Date(booking.date),
                    };
                }),
            );
            setBookingsLoaded(true);
        });
    }, [demo, valueFormatter, requestClient]);

    const BillingActions = useMemo(
        () => ({
            valueFormatter,
        }),
        [valueFormatter],
    );

    return {
        BillingActions,
        bookings,
        selectedLanguage,
        userSettings,
        demo,
        i18n,
        bookingsLoaded,
        getBreakpoint,
        windowWidth,
        handleNavigate,
    };
};

export default useBilling;
